// extracted by mini-css-extract-plugin
module.exports = {"children":"styles_children__1iOmO"};